import { CacheableState } from '@utils/cacheable-state';

export interface SuperAdminHomeState {
  allCustomers: CacheableState<Array<any>>;
  allActiveUsers: CacheableState<Array<any>>;
  notifications: CacheableState<Array<any>>;
  notificationsCount: CacheableState<number>;
  deleteCompany: CacheableState<Array<any>>;
  markAsReadNotification: CacheableState<Array<any>>;
}

export function superAdminHomeInitialState(): SuperAdminHomeState {
  return {
    allCustomers: new CacheableState(),
    allActiveUsers: new CacheableState(),
    notifications: new CacheableState(),
    notificationsCount: new CacheableState(),
    deleteCompany: new CacheableState(),
    markAsReadNotification: new CacheableState(),
  };
}
